(function(){
  function init(){
    const root=document.querySelector('.lmu-pdp-v10');
    if(!root)return;
    const grid=root.querySelector('[data-bulk-grid]');
    const form=root.querySelector('[data-product-form]');
    const variantSource=document.querySelector('[data-product-variants]');
    if(!grid||!form||!variantSource)return;

    /* Current LMU product pages use lmu-bulk-order.js as the single size-grid owner.
       Keep this legacy renderer available only for older layouts. */
    if(root.querySelector('.lmu-size-order[data-bulk-order]'))return;

    if(grid.dataset.lmuMatrixBound==='true')return;
    grid.dataset.lmuMatrixBound='true';

    let variants=[];
    try{variants=JSON.parse(variantSource.textContent||'[]')}catch(e){variants=[]}
    if(!variants.length)return;

    const selects=Array.from(form.querySelectorAll('select[data-option-index]'));
    function optionIndex(pattern){
      for(let i=0;i<selects.length;i++){
        const field=selects[i].closest('.lmu-pdp-v10__field');
        const label=field&&field.querySelector('label');
        if(label&&pattern.test(label.textContent||''))return Number(selects[i].dataset.optionIndex);
      }
      return -1;
    }
    const colourIndex=optionIndex(/colou?r/i);
    const sizeIndex=optionIndex(/size/i);
    if(sizeIndex<0)return;

    function currentColour(){
      if(colourIndex<0)return null;
      const select=selects.find(s=>Number(s.dataset.optionIndex)===colourIndex);
      return select?select.value:null;
    }

    function normaliseSize(value){
      let s=String(value==null?'':value).trim().toUpperCase().replace(/[\s_-]+/g,'');
      const words={
        'XXEXTRASMALL':'XXS','EXTRAEXTRASMALL':'XXS','XXSMALL':'XXS',
        'EXTRASMALL':'XS','XSMALL':'XS',
        'SMALL':'S','MEDIUM':'M','LARGE':'L',
        'EXTRALARGE':'XL','XLARGE':'XL',
        'EXTRAEXTRALARGE':'2XL','XXLARGE':'2XL','XXL':'2XL',
        'XXXLARGE':'3XL','XXXL':'3XL',
        'XXXXLARGE':'4XL','XXXXL':'4XL',
        'XXXXXLARGE':'5XL','XXXXXL':'5XL',
        'XXXXXXLARGE':'6XL','XXXXXXL':'6XL'
      };
      if(words[s])s=words[s];
      const xBefore=s.match(/^(X{2,8})L$/);
      if(xBefore)s=xBefore[1].length+'XL';
      const xAfter=s.match(/^(\d+)X$/);
      if(xAfter)s=xAfter[1]+'XL';
      return s;
    }

    function sizeRank(value){
      const s=normaliseSize(value);
      const alpha={'XXXS':10,'XXS':20,'XS':30,'S':40,'M':50,'L':60,'XL':70};
      if(Object.prototype.hasOwnProperty.call(alpha,s))return [0,alpha[s],s];
      const multi=s.match(/^(\d+)XL$/);
      if(multi)return [0,70+(Number(multi[1])-1)*10,s];
      const numeric=s.match(/^(\d+(?:\.\d+)?)$/);
      if(numeric)return [1,Number(numeric[1]),s];
      const waist=s.match(/^(\d+)(?:IN|INCH|INCHES)$/);
      if(waist)return [1,Number(waist[1]),s];
      return [2,0,s];
    }

    function compareSizes(a,b){
      const ar=sizeRank(a.options[sizeIndex]);
      const br=sizeRank(b.options[sizeIndex]);
      if(ar[0]!==br[0])return ar[0]-br[0];
      if(ar[1]!==br[1])return ar[1]-br[1];
      return ar[2].localeCompare(br[2],undefined,{numeric:true,sensitivity:'base'});
    }

    function stockCopy(variant){
      if(!variant)return['Currently unavailable','Not available in selected colour',false];
      if(!variant.available)return['Currently unavailable','Please choose another size',false];
      return['Available to order','Supplier stock checked at order',false];
    }

    function escapeHtml(value){
      return String(value==null?'':value)
        .replace(/&/g,'&amp;')
        .replace(/</g,'&lt;')
        .replace(/>/g,'&gt;')
        .replace(/\"/g,'&quot;')
        .replace(/'/g,'&#039;');
    }

    function render(){
      const saved={};
      grid.querySelectorAll('[data-bulk-qty]').forEach(input=>{saved[String(input.dataset.variant)]=Number(input.value)||0});
      const colour=currentColour();
      const matching=variants.filter(v=>colourIndex<0||!colour||v.options[colourIndex]===colour);
      const seen=new Set();
      const rows=matching.filter(v=>{
        const size=v.options[sizeIndex];
        if(seen.has(size))return false;
        seen.add(size);
        return true;
      }).sort(compareSizes);

      if(!rows.length){
        grid.innerHTML='<p>No sizes are available for the selected colour.</p>';
        grid.dispatchEvent(new Event('change',{bubbles:true}));
        return;
      }

      grid.innerHTML=rows.map(v=>{
        const size=v.options[sizeIndex];
        const copy=stockCopy(v);
        const enabled=!!v.available;
        const qty=saved[String(v.id)]||0;
        return '<div class="lmu-size-card'+(enabled?'':' is-unavailable')+(copy[2]?' is-fast':'')+'">'+
          '<div class="lmu-size-card__head"><strong>'+escapeHtml(size)+'</strong></div>'+ 
          '<div class="lmu-size-card__stepper">'+
            '<button type="button" data-size-minus aria-label="Decrease '+escapeHtml(size)+' quantity" '+(enabled?'':'disabled')+'>−</button>'+ 
            '<input type="number" min="0" step="1" value="'+qty+'" data-bulk-qty data-variant="'+v.id+'" aria-label="'+escapeHtml(size)+' quantity" '+(enabled?'':'disabled')+'>'+ 
            '<button type="button" data-size-plus aria-label="Increase '+escapeHtml(size)+' quantity" '+(enabled?'':'disabled')+'>+</button>'+ 
          '</div>'+ 
          '<div class="lmu-size-card__stock"><strong>'+copy[0]+'</strong><span>'+copy[1]+'</span></div>'+ 
        '</div>';
      }).join('');
      grid.dispatchEvent(new Event('input',{bubbles:true}));
      grid.dispatchEvent(new Event('change',{bubbles:true}));
    }

    /* Quantity +/- is intentionally handled only by lmu-bulk-order.js.
       Keeping a second handler here caused every click to increment twice. */

    grid.addEventListener('change',function(event){
      const input=event.target.closest&&event.target.closest('[data-bulk-qty]');
      if(input&&Number(input.value)<0)input.value='0';
    });

    selects.forEach(select=>select.addEventListener('change',function(){window.setTimeout(render,0)}));
    render();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
